import T from 'T'

export const BILLING_TABS_ID = {
  CREATE_INVOICES_TAB_ID: 'create_invoices',
  INVOICES_TAB_ID: 'invoices',
  SENT_INVOICES_TAB_ID: 'sent_invoices',
  PAYMENTS_TAB_ID: 'payments',
  ACCOUNTS_RECEIVABLE_TAB_ID: 'accounts_receivable',
}

export const INVOICE_STATUS = {
  PAID: 'Paid',
  PARTIAL: 'Partial', // Draft
  UNPAID: 'Unpaid',
  VOID: 'Void',
}

export const INVOICE_GENERATION_STATUS = {
  Initialized: 'Initialized',
  Started: 'Started',
  Completed: 'Completed',
  Failed: 'Failed',
  Regeneration_Started: 'Regeneration_Started',
  Regeneration_Completed: 'Regeneration_Completed',
  Regeneration_Failed: 'Regeneration_Failed',
  'N/A': 'N/A',
}

export const INVOICE_GENERATION_STATUS_LABELS = {
  Started: 'Generating',
  Completed: 'Success',
  Failed: 'Failed',
  Regeneration_Started: 'Regenerating',
  Regeneration_Completed: 'Successful regeneration',
  Regeneration_Failed: 'Failed regeneration',
  'N/A': 'N/A',
}

export const INVOICE_TYPE = {
  RECURRING: 'RECURRING',
  MANUAL: 'MANUAL',
}

export const PAYMENT_TERMS = ['Net [X] Days', 'Due on Receipt']

export const PAYMENT_DUE_DATE_TYPES = {
  NET_DAYS: 'NetDays',
  SPECIFIC_DAY_OF_MONTH: 'SpecificDayOfMonth',
}

export const PAYMENT_DUE_DATE_TYPE_OPTIONS = [
  { label: T.PAYMENT_DUE_NET_DAYS, value: PAYMENT_DUE_DATE_TYPES.NET_DAYS },
  { label: T.PAYMENT_DUE_SPECIFIC_DAY_OF_MONTH, value: PAYMENT_DUE_DATE_TYPES.SPECIFIC_DAY_OF_MONTH },
]

export const INTERVALS = ['1', '2', '3', '4', '5', '6', '28']

export const RECURRENCE_INTERVALS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']

export const BILLING_CYCLE_LABELS = ['Hour', 'Day', 'Week', 'Month', 'Quarter', 'Year']

export const BILLING_CYCLES = {
  MONTH: 'Month',
  QUARTER: 'Quarter',
  YEAR: 'Year',
}
export const CYCLES = ['Manual', 'Day', 'Week', 'Month', 'Quarter', 'Year']

export const DAY_BASED_PRORATE = 1
export const EVENT_BASED_PRORATE = 2
export const PRORATION_OPTIONS = [
  { key: DAY_BASED_PRORATE, value: T.DAY_BASED_PRORATION },
  { key: EVENT_BASED_PRORATE, value: T.EVENT_BASED_PRORATION },
]

export const BILLING_TABLE_BACKEND_VALUES = {
  ACCOUNT_CREDIT: 'AccountCredit',
  CREDIT_CARD: 'CreditCredit',
}

export const DELIVERY_METHODS = ['Pdf', 'Portal', 'Paper', 'Postcard']

export const DELIVERY_MAPPING_VALUES = {
  Pdf: T.EMAIL,
  Portal: T.PORTAL,
  Paper: T.PDF,
}

export const SUSPENSION_DAYS_LATE_DEFAULT_THRESHOLD = 1

export const BILLING_PERIOD_SUPPORTED_VIEW = {
  MONTH: 'Month',
  QUARTER: 'Quarter',
  BI_ANNUALLY: 'BiAnnually',
  TWENTY_EIGHT_DAYS: 'TwentyEightDays',
  DEFAULT: 'Default',
}
